import React from "react";
import { motion } from "framer-motion";
import {
  FaCog,
  FaIndustry,
  FaRocket,
  FaAward,
  FaTools,
  FaShieldAlt,
  FaCheckCircle,
  FaMicrochip,
  FaCogs,
  FaWrench,
} from "react-icons/fa";
import dexterImage1 from "../../../assets/dexter-images/dexter-1.jpg";
import dexterImage2 from "../../../assets/dexter-images/dexter-2.jpg";

function MachiningCapabilities() {
  return (
    <div className="service-page machining-page">
      <motion.div
        className="service-hero"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <div className="hero-content">
            <h1>Machining Capabilities</h1>
            <p>Precision Engineering Excellence with Advanced Technology</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        className="service-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <div className="container">
          {/* Hero Section with Image */}
          <div className="service-hero-section">
            <div className="hero-text">
              <h2>Machining Turning Excellence</h2>
              <p>
                DexteR Technology specializes in high-precision turning
                operations with close tolerance machining up to 10 microns. Our
                advanced machines are equipped with sophisticated tooling and
                precision instruments to perform intricate machining operations
                with exceptional accuracy.
              </p>
              <div className="hero-features">
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>10 Micron Precision</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>Advanced Technology</span>
                </div>
                <div className="feature-item">
                  <FaCheckCircle className="feature-icon" />
                  <span>Quality Certified</span>
                </div>
              </div>
            </div>
            <div className="hero-image">
              <img src={dexterImage1} alt="CNC Turning Operations" />
            </div>
          </div>

          {/* Capabilities Grid */}
          <div className="capabilities-section">
            <h2>Our Machining Capabilities</h2>
            <div className="capabilities-grid">
              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaCog />
                </div>
                <h3>CNC Turning</h3>
                <p>
                  Precision turning operations with close tolerance up to 10
                  microns for critical applications
                </p>
                <ul>
                  <li>High-speed turning</li>
                  <li>Multi-axis operations</li>
                  <li>Complex geometries</li>
                  <li>Thread cutting</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaIndustry />
                </div>
                <h3>VMC Milling</h3>
                <p>
                  Advanced milling capabilities for complex 3D geometries and
                  precision components
                </p>
                <ul>
                  <li>3-axis milling</li>
                  <li>Surface finishing</li>
                  <li>Pocket machining</li>
                  <li>Contour cutting</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaRocket />
                </div>
                <h3>Advanced Manufacturing</h3>
                <p>
                  State-of-the-art manufacturing processes with cutting-edge
                  technology
                </p>
                <ul>
                  <li>Automated processes</li>
                  <li>Quality control</li>
                  <li>Batch production</li>
                  <li>Custom solutions</li>
                </ul>
              </motion.div>

              <motion.div
                className="capability-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="card-icon">
                  <FaAward />
                </div>
                <h3>Specialized Processes</h3>
                <p>
                  Specialized machining processes for unique requirements and
                  applications
                </p>
                <ul>
                  <li>Traub operations</li>
                  <li>Grinding services</li>
                  <li>Hobbing & milling</li>
                  <li>Finishing operations</li>
                </ul>
              </motion.div>
            </div>
          </div>

          <div className="process-image-section">
            <motion.div
              className="process-image"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img src={dexterImage2} alt="CNC Manufacturing Process" />
              <div className="image-overlay">
                <div className="overlay-content">
                  <h3>Advanced Manufacturing Process</h3>
                  <p>
                    State-of-the-art CNC machining with precision engineering
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Materials Section */}
          <div className="materials-section">
            <h2>Materials We Work With</h2>
            <div className="materials-grid">
              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaTools />
                </div>
                <h3>Stainless Steel (SS)</h3>
                <p>
                  High-quality stainless steel components with excellent
                  corrosion resistance
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaCogs />
                </div>
                <h3>Aluminum</h3>
                <p>
                  Lightweight aluminum components with excellent
                  strength-to-weight ratio
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaShieldAlt />
                </div>
                <h3>Brass</h3>
                <p>
                  Precision brass components with excellent conductivity and
                  durability
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaWrench />
                </div>
                <h3>Gun Metal</h3>
                <p>
                  Specialized gun metal components for specific industrial
                  applications
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaMicrochip />
                </div>
                <h3>Mild Steel (MS)</h3>
                <p>
                  Cost-effective mild steel components for various industrial
                  applications
                </p>
              </motion.div>

              <motion.div
                className="material-card"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="material-icon">
                  <FaRocket />
                </div>
                <h3>Custom Alloys</h3>
                <p>
                  Specialized custom alloys for unique requirements and
                  applications
                </p>
              </motion.div>
            </div>
          </div>

          {/* Machine Specifications */}
          {/* <div className="specs-section">
            <h2>Machine Specifications</h2>
            <div className="specs-grid">
              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <h3>CNC Machines</h3>
                <p>
                  2 Advanced CNC machines with proper inspection & testing
                  facilities
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h3>Precision Tolerance</h3>
                <p>
                  Close tolerance machining up to 10 microns for critical
                  applications
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <h3>CAD/CAM Software</h3>
                <p>
                  Advanced software including Fusion 360, SolidWorks, and
                  Mastercam
                </p>
              </motion.div>

              <motion.div
                className="spec-item"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <h3>Quality Control</h3>
                <p>
                  Comprehensive quality control processes with certified
                  standards
                </p>
              </motion.div>
            </div>
          </div> */}

          {/* Why Choose Us Section */}
          {/* <div className="why-choose-section">
            <h2>Why Choose Our Machining Services?</h2>
            <div className="benefits-grid">
              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Precision Engineering</h3>
                <p>
                  Ultra-precise machining with 10-micron tolerance for critical
                  applications
                </p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Advanced Technology</h3>
                <p>State-of-the-art machines with cutting-edge technology</p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Expert Team</h3>
                <p>
                  Skilled technicians with years of experience in precision
                  manufacturing
                </p>
              </motion.div>

              <motion.div
                className="benefit-item"
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <FaCheckCircle className="benefit-icon" />
                <h3>Quality Assurance</h3>
                <p>
                  Comprehensive quality control with certified processes and
                  standards
                </p>
              </motion.div>
            </div>
          </div> */}

          {/* Process Image */}
        </div>
      </motion.div>
    </div>
  );
}

export default MachiningCapabilities;
